import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://www.sozialgerichtsbarkeit.de/api/';

export const login = async (username, password) => {
    try {
        const formData = new FormData();
        formData.append('username', username);
        formData.append('password', password);
        
        const response = await axios.post(`${API_URL}/auth/login`, formData);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const logout = () => {
    localStorage.removeItem('token');
};

export const getToken = () => {
    return localStorage.getItem('token');
};

export const isAuthenticated = () => {
    return !!getToken();
}; 